import './App.css';
import {Box, createTheme, CssBaseline, ThemeProvider, Typography} from '@mui/material';
import Login from './login/components/OperatorLogin';
import {useEffect, useState} from 'react';
import {cookieExists} from './common/utils/CookieUtils';
import {LoadingProvider} from './loading-overlay/LoadingContext';
import Header from './common/components/Header';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AssignPlayersTab from './assign-display-names/components/AssignPlayersTab';

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'trueVRsystems © is a brand of RedCube GmbH '}
      {new Date().getFullYear()}
    </Typography>
  );
}

let theme = createTheme({
  palette: {
    primary: {
      light: '#64b8fa',
      main: '#081425',
      dark: '#005b96',
    },
    secondary: {
      light: '#68fbe6',
      main: '#20c7b4',
      dark: '#009584',
    },
  },
  typography: {
    h2: {
      fontWeight: 500,
      fontSize: '2.5em',
      letterSpacing: 0.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
  mixins: {
    toolbar: {
      minHeight: '5vh',
    },
  },
});

theme = {
  ...theme,
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#081627',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'outlined',
        size: 'large',
      },
      styleOverrides: {
        root: {
          marginTop: theme.spacing(3),
          marginBottom: theme.spacing(2),
          textTransform: 'none',
        },
        contained: {
          'boxShadow': 'none',
          '&:active': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          marginLeft: theme.spacing(1),
        },
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: theme.palette.common.white,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          margin: '0 16px',
          minWidth: 0,
          padding: 0,
          [theme.breakpoints.up('md')]: {
            padding: 0,
            minWidth: 0,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#4fc3f7',
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          'color': 'inherit',
          'minWidth': 'auto',
          'marginRight': theme.spacing(2),
          '& svg': {
            fontSize: 20,
          },
        },
      },
    },
  },
};

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const checkIfLoggedIn = () => {
    setIsLoggedIn(cookieExists('loggedInIndicator'));
  };

  useEffect(() => {
    checkIfLoggedIn();
  }, []);

  let mainContent;
  if (isLoggedIn) {
    mainContent = <AssignPlayersTab/>;
  } else {
    mainContent = <Login onLoginAttempt={checkIfLoggedIn}/>;
  }

  return (
    <ThemeProvider theme={theme}>
      <LoadingProvider>
        <Box sx={{display: 'flex', minHeight: '100vh'}}>
          <CssBaseline/>
          <Box sx={{flex: 1, display: 'flex', flexDirection: 'column'}}>
            <Header onAuthChange={checkIfLoggedIn} showTabs={isLoggedIn}/>
            <Box component="main" sx={{flex: 1, py: 6, px: 4, bgcolor: '#eaeff1'}}>
              {mainContent}
            </Box>
            <Box component="footer" sx={{p: 2, bgcolor: '#eaeff1'}}>
              <Copyright/>
            </Box>
          </Box>
        </Box>
        <ToastContainer/>
      </LoadingProvider>
    </ThemeProvider>
  );
}

export default App;
